import { useEffect,useState } from 'react';

type LazyLoaderProps = {
  show?: boolean;
  delay?: number;
  loader: React.ReactNode;
};

const LazyLoader = (props: LazyLoaderProps) => {
  const { show = false, delay = 0 } = props;
  const [showLoader, setShowLoader] = useState(false);
  useEffect(() => {
    let timeout: NodeJS.Timeout;
    if (!show) {
      setShowLoader(false);
      return;
    }
    if (delay === 0) {
      setShowLoader(true);
    } else {
      timeout = setTimeout(() => setShowLoader(true), delay);
    }
    return () => {
      clearInterval(timeout);
    };
  }, [show, delay]);
  return showLoader && props.loader;
};
export default LazyLoader;
